import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { HERO, SHOTS } from "../mock";
import DeviceFrame from "./renn/DeviceFrame";
import Reveal from "./Reveal";

const Hero = () => {
  return (
    <section id="home" className="relative pt-28 lg:pt-36 pb-16 lg:pb-24">
      <div className="absolute inset-0 grid-noise opacity-[0.25] -z-10" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-5">
            {HERO.eyebrow}
          </p>
          <h1 className="font-display text-5xl lg:text-[4.2rem] leading-[1.02] font-bold text-[#F5F7FB]">
            {HERO.headline}
          </h1>
          <p className="mt-6 text-lg text-[#8290A8] max-w-xl leading-relaxed">{HERO.copy}</p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <a
              href="#beta"
              className="btn-emerald inline-flex items-center justify-center gap-2 bg-[#10C98A] text-[#050A12] font-semibold px-7 py-4 rounded-full"
            >
              {HERO.primary}
              <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href="#how-it-works"
              className="inline-flex items-center justify-center gap-2 border border-[#29354A] hover:border-[#10C98A]/60 text-[#F5F7FB] font-semibold px-7 py-4 rounded-full transition-colors"
            >
              {HERO.secondary}
            </a>
          </div>

          <div className="mt-8 flex items-start gap-3 text-[#8290A8] text-sm max-w-md">
            <ShieldCheck className="w-5 h-5 text-[#10C98A] shrink-0 mt-0.5" />
            <span>{HERO.trust}</span>
          </div>
        </Reveal>

        <Reveal delay={120} className="flex justify-center lg:justify-end">
          <DeviceFrame src={SHOTS.moves} alt="Renn app showing your top three money moves" className="w-full max-w-[360px]" />
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
